import React, { ReactNode } from 'react';

import styles from './NavigateBackBtn.module.css';

import arrowLeft from 'assets/icons/arrow left.png';

interface INavigateBackBtnProps {
  onBackBtnClick: () => void;
  children: ReactNode;
}

const NavigateBackBtn = ({ onBackBtnClick, children }: INavigateBackBtnProps) => (
  <button type="button" className={styles.btn} onClick={onBackBtnClick}>
    <div className={styles.leftArrowIcon}>
      <img src={arrowLeft} alt="arrow left icon" />
    </div>
    {children}
  </button>
);

export default NavigateBackBtn;
